export default __webpack_public_path__ + "static/apertura2-20b61dc82cbadb42642e0bcd72540b52.png";